import React from 'react';
import GenericAddModal from "../../../layouts/GenericInput/GenericAddModal";

const AutocompleteAddData = ({ input, onAdd, open, setOpen }) => {
    const handleCreate = (resp) => {
        // the generic add item will pass the fetch response
        onAdd(resp);
        setOpen(false);
    }

    return (
        <GenericAddModal
            open={open}
            handleModalClose={() => setOpen(false)}
            inputs={input.inputs}
            createAction={input.addNew}
            onCreate={handleCreate}
        />
    )
}

export default AutocompleteAddData;
